import type { FC, ReactElement } from 'react';

import SearchFiltersSeparator from '../../components/search_filters_separator/search_filters_separator';
import { COLLECTION_PAGE_ROUTE } from '../../constants/routes';
import { useAppSelector } from '../../store/react_redux_typed';
import RemovableFilterValueWrapper from '../../ui/forms/field_wrappers/removable_filter_value/removable_filter_value';
import SearchInSubcollections from './search_in_subcollections/search_in_subcollections';

type Props = {
  newAssetIds?: string[];
  collectionAncestors: boolean;
};

const SearchFilterElements: FC<Props> = ({
  newAssetIds,
  collectionAncestors,
}) => {
  const route = useAppSelector((state) => state.routeParams.route);

  const elements: ReactElement[] = [];

  if (newAssetIds) {
    elements.push(
      <RemovableFilterValueWrapper
        name="filters.id"
        value={newAssetIds}
        iconName="load_up"
        infoText="New Assets"
        key="wrapper"
      />,
    );

    elements.push(<SearchFiltersSeparator key="wrapper-separator" />);
  }

  if (route === COLLECTION_PAGE_ROUTE) {
    elements.push(
      <SearchInSubcollections
        value={collectionAncestors}
        key="subcollection-search"
      />,
    );

    elements.push(<SearchFiltersSeparator key="subcollection-separator" />);
  }

  // remove the last separator
  if (elements.length > 0) {
    elements.pop();
  }

  return elements;
};

export default SearchFilterElements;
